export default __webpack_public_path__ + "static/pic-1-ed30f74e057a14c301ba80a8975e7e61.png";